import { useEffect, useMemo, useState } from "react";
import { Accel } from "../../api/accel";
import {
  useTransactionContext,
  TransactionContextValues,
} from "../../contexts/TransactionContext/TransactionContext"; // Changed to default import

import useSWR from "swr";
import useAccelContext from "../../contexts/AccelContext";

export const useTransactions = (): TransactionContextValues => {
  const { auth, companyId, apiUrl } = useAccelContext();

  const [loadingStatus, setLoadingStatus] = useState("initial"); // Add this line


  const {
    data: responseData,
    error: responseError,
    isLoading,
    isValidating, // Ensure this is typed as boolean
    mutate,
  } = useSWR(
    `bank-transactions-${companyId}`,
    Accel.getTransactions(apiUrl, auth.access_token, {
      params: { companyId },
    })
  );

  // Use useEffect to update the context when responseData changes

  useEffect(() => {
    if (isLoading && loadingStatus === "initial") {
      setLoadingStatus("loading");
      return;
    }

    if (!isLoading && loadingStatus === "loading") {
      setLoadingStatus("complete");
      return;
    }
  }, [isLoading]);

  const refetch = () => {
    mutate();
    ctMutate();
  };
const {
  data: ctData,
  error: ctError,
  isLoading: ctLoadingStatus,
  isValidating: ctIsValidating,
  mutate: ctMutate,
} = useSWR(
  `classified-transactions-${companyId}`,
  Accel.classifyTransactions(apiUrl, auth.access_token, {
      params: { companyId },
    })
  );


  return {
    transactions: responseData || [], // Ensure transactions is always an array
    mutate,
    loadingStatus,
    isValidating, // Explicitly cast isValidating to boolean
    refetch,
    error: responseError,
    classifiedTransactions: ctData || [],
    ctLoadingStatus: ctLoadingStatus.toString(),
    ctIsValidating: ctIsValidating,
    ctRefetch: ctMutate,
    ctError: ctError,
    ctMutate: ctMutate
  };
};
export default useTransactions;
